var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20V18H6.6L8.575 11.425C8.70833 10.9917 8.95417 10.6458 9.3125 10.3875C9.67083 10.1292 10.0667 10 10.5 10H13.5C13.9333 10 14.3292 10.1292 14.6875 10.3875C15.0458 10.6458 15.2917 10.9917 15.425 11.425L17.4 18H19V20H5ZM8.7 18H15.3L13.5 12H10.5L8.7 18ZM11 8V3H13V8H11ZM16.95 10.475L15.525 9.05L19.075 5.525L20.475 6.925L16.95 10.475ZM18 15V13H23V15H18ZM7.05 10.475L3.525 6.925L4.925 5.525L8.475 9.05L7.05 10.475ZM1 15V13H6V15H1Z",
    fill: "#888888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.06aea9e230b737f2c7b7e7250506d400.svg";
export { ForwardRef as ReactComponent };